module.exports = __webpack_public_path__ + "img/FutureBillionaire.05a6c08b.jpg";